import { defineComponent as _defineComponent } from 'vue'
import { store } from "@/store/store";
import Navigation from "../../NavigationContainer.vue";
import InquiryNavigation from "../../InquiryNavigationContainer.vue";
import InquiryLinkNavigation from "../../InquiryLinkNavigationContainer.vue";
import { ref, onMounted, reactive, onUpdated } from "vue";
import { useI18n } from "vue3-i18n";
import ResponseData from "@/types/ResponseData";
import ManualInfoDataService from "@/services/ManualInfoDataService";
import Loading from "@/components/home/Loading";
import Alert from "@/components/scan/parts/Alert.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const manualInfo = reactive([]);
const getData = ref(false);
const title = ref("Manual List");

onMounted(function () {
  isLoading.value = true;
  getManualList();
});

const getManualList = () => {
  isLoading.value = true;
  manualInfo.splice(0);
  const data = {};

  //二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";

  // get Manual Data
  ManualInfoDataService.getManual(data)
    .then((response: ResponseData) => {
      if (response.data.length !== 0) {
        manualInfo.push(response.data);
      }
      getData.value = true;
      isLoading.value = false;
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err010");
      alertState.value = "error";
      isLoading.value = false;
    });
};

/** 各リンクを押下時の処理関数 */
const openManualFile = (txtName, fileSize) => {
  // ファイルサイズが空白なら初期データによって、ファイルがない
  if (fileSize == "") {
    alert("Target file does not exist!!!");
    isLoading.value = false;
    return;
  }
  const data = {
    filename: txtName,
  };
  ManualInfoDataService.getManualFilebyName(data)
    .then((response: ResponseData) => {
      if (response.status == 200) {
        var data = response.data;
        if (txtName.split(".")[1] == "pdf" || txtName.split(".")[1] == "PDF") {
          // const blob = new Blob([data], {
          //   type: "application/pdf; charset=UTF-8",
          // });
          // const file = new File([blob], txtName, {
          //   type: "application/pdf; charset=UTF-8",
          // });

          // const url = window.URL.createObjectURL(file);
          // window.open(url).focus();

          window.open(data.filePath)?.focus();
        } else {
          const blob = new Blob([data], {
            type: "application/octat-stream; charset=UTF-8",
          });
          const file = new File([blob], txtName, {
            type: "application/octat-stream; charset=UTF-8",
          });

          const url = window.URL.createObjectURL(file);

          const alink = document.createElement("a");
          alink.href = url;
          alink.download = txtName;
          alink.click();

          window.URL.revokeObjectURL(url);
        }
      }

      isLoading.value = false;
    })
    .catch((e: Error) => {
      // file not found
      alert("Target file does not exist!!!");
      console.log(e);
      isLoading.value = false;
    });
};

onUpdated(function () {
  try {
    var tableHeight = 0;
    var dataHeight = document.getElementById("tblmanualInfo")?.clientHeight;
    if (dataHeight != 0) {
      tableHeight = document.getElementById("manualdiv")?.clientHeight;
      if (dataHeight > tableHeight - 60) {
        document.getElementById("tblbodydiv").style.width = "100%";
      } else {
        document.getElementById("tblbodydiv").style.width = "calc(100% - 16px)";
      }
    }
  } catch (e) {
    isLoading.value = false;
  }
});

const openWindow = (jumpUrl) => {
  var url = `${process.env.VUE_APP_ONPREMISE_URL_DOMAIN}main/TO_V2.asp?DEST=${jumpUrl}&CTLNO=${store.getters.loginNumber}`;
  window.open(url, "_blank");
};

const __returned__ = { isLoading, alertMessage, alertState, i18n, manualInfo, getData, title, getManualList, openManualFile, openWindow, Navigation, InquiryNavigation, InquiryLinkNavigation, Loading, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})